import { render, staticRenderFns } from "./CustomFieldsDisplay.vue?vue&type=template&id=546f9b86"
import script from "./CustomFieldsDisplay.vue?vue&type=script&lang=js"
export * from "./CustomFieldsDisplay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports